"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_icons_1 = require("@carvana/helios-icons");
var helios_navigation_1 = require("@carvana/helios-navigation");
var helios_styles_1 = require("@carvana/helios-styles");
var react_1 = require("react");
var Tooltip_styles_1 = require("./Tooltip.styles");
var Tooltip = function (_a) {
    var _b = _a.delay, delay = _b === void 0 ? 200 : _b, _c = _a.direction, direction = _c === void 0 ? 'bottom' : _c, content = _a.content, children = _a.children, header = _a.header, headerIcon = _a.headerIcon, slot = _a.slot, _d = _a.width, width = _d === void 0 ? '327px' : _d;
    var timeout;
    var _e = (0, react_1.useState)(false), active = _e[0], setActive = _e[1];
    var showTip = function () {
        timeout = setTimeout(function () {
            setActive(true);
        }, delay);
    };
    var hideTip = function () {
        clearInterval(timeout);
        setActive(false);
    };
    return ((0, jsx_runtime_1.jsxs)(Tooltip_styles_1.Wrapper, __assign({ onMouseEnter: showTip, onMouseLeave: hideTip }, { children: [children, active && ((0, jsx_runtime_1.jsxs)(Tooltip_styles_1.TooltipTip, __assign({ width: width, className: direction }, { children: [header && ((0, jsx_runtime_1.jsxs)(Tooltip_styles_1.Header, { children: [(0, jsx_runtime_1.jsxs)(Tooltip_styles_1.HeaderWrapper, { children: [(0, jsx_runtime_1.jsx)("div", { children: headerIcon }), header] }), (0, jsx_runtime_1.jsx)(helios_navigation_1.Button, __assign({ size: "sm", variant: "tertiary", icon: true, onClick: hideTip }, { children: (0, jsx_runtime_1.jsx)(helios_icons_1.XIcon, { color: helios_styles_1.text.inverse }) }))] })), content, slot && (0, jsx_runtime_1.jsx)(Tooltip_styles_1.Slot, { children: slot })] })))] })));
};
exports.Tooltip = Tooltip;
